import r from "./RollingNumber.module.css";

// A number that rolls up into place when it changes, in place of a library.
// Each new value mounts fresh and plays a short rise. Under reduced motion it
// simply changes.
export function RollingNumber({ value, format }: { value: number; format?: (value: number) => string }) {
  const text = format ? format(value) : String(value);
  return (
    <span className={r.roll}>
      <span key={text} className={r.in}>
        {text}
      </span>
    </span>
  );
}
